import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetLicenseDataResData } from "./GetLicenseDataResData";

const ENDPOINT = "/license";

export class GetLicenseDataCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    public async execute(): Promise<GetLicenseDataResData> {
        var res = await this.executeCommand();
        return new GetLicenseDataResData(res);
    }
}
